import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateProperty, fetchAllProperties } from '../../redux/actions/propertyActions';
import { toast } from 'react-toastify';

const EditProperty = ({ selectedProperty, handleCloseModal }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({ ...selectedProperty });
  const[disableButton, setDisableButton] = useState(false);

  const units = Array.isArray(formData?.units) ? formData.units : [];

  useEffect(() => {
    setFormData({ ...selectedProperty });
  }, [selectedProperty]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleUnitChange = (idx, field, value) => {
    setFormData((prev) => {
      const updatedUnits = Array.isArray(prev.units) ? [...prev.units] : [];
      updatedUnits[idx] = { ...updatedUnits[idx], [field]: value };
      return { ...prev, units: updatedUnits };
    });
  };

  const handleUpdate = async () => {
    const payload = {
      property_name: formData.property_name,
      street_number: formData.street_number,
      street_name: formData.street_name,
      city: formData.city,
      postal_code: formData.postal_code,
      province_id: formData.province_id,
      units_data: units
    };

      setDisableButton(true);
     try{
    const res = await dispatch(
      updateProperty({
        propertyId: selectedProperty.id,
        payload
      })
    );
    if (res.meta.requestStatus === 'fulfilled') {
      toast.success('Property updated successfully!');
      dispatch(fetchAllProperties());
      handleCloseModal();
    }else {
      const msg = res.payload?.message || 'Failed to update property. Please try again.';
      handleCloseModal();
      toast.error(msg);
    }
     
  }   catch (error) {
      // toast.error('Failed to update property. Please try again.');
    } finally {
      setDisableButton(false);
    }
  };

  if (!selectedProperty) return null;

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 9999 }}>
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">

            {/* HEADER */}
            <div className="modal-header bg-warning text-dark">
              <h5 className="modal-title">
                Edit Property
              </h5>
              <button type="button" className="btn-close" onClick={handleCloseModal} />
            </div>

            {/* BODY */}
            <div className="modal-body">

              {/* BASIC INFO */}
              <h6 className="border-bottom pb-2 mb-3">Basic Information</h6>
              <div className="row g-3 mb-4">
                <div className="col-md-12">
                  <label className="form-label">Property Name</label>
                  <input
                    className="form-control"
                    name="property_name"
                    value={formData.property_name || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* ADDRESS */}
              <h6 className="border-bottom pb-2 mb-3">Address Details</h6>
              <div className="row g-3 mb-4">
                <div className="col-md-3">
                  <label className="form-label">Street Number</label>
                  <input
                    className="form-control"
                    name="street_number"
                    value={formData.street_number || ''}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-5">
                  <label className="form-label">Street Name</label>
                  <input
                    className="form-control"
                    name="street_name"
                    value={formData.street_name || ''}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">City</label>
                  <input
                    className="form-control"
                    name="city"
                    value={formData.city || ''}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Postal Code</label>
                  <input
                    className="form-control"
                    name="postal_code"
                    value={formData.postal_code || ''}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* PROPERTY DETAILS */}
              <h6 className="border-bottom pb-2 mb-3">Property Details</h6>
              <div className="row g-3 mb-3">
                <div className="col-md-4">
                  <label className="form-label">Total Units</label>
                  <input
                    className="form-control"
                    value={units.length}
                    disabled
                    readOnly
                  />
                </div>
              </div>

              {/* UNIT DETAILS */}
              <h6 className="border-bottom pb-2 mb-3">Unit Details</h6>
              {units.length > 0 ? (
                <div className="row g-3">
                  {units.map((unit, index) => (
                    <div className="col-12 border rounded p-3 bg-light" key={unit.id}>
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label className="form-label mb-1">Unit </label>
                          <input
                            className="form-control"
                            value={unit.unit || ''}
                            onChange={(e) => handleUnitChange(index, 'unit', e.target.value)}
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label mb-1">Type</label>
                          <select
                            className="form-select"
                            value={unit.unit_type || ''}
                            onChange={(e) => handleUnitChange(index, 'unit_type', e.target.value)}
                          >
                            <option value="">Select unit type</option>
                            <option value="Apartment">Apartment</option>
                            <option value="Basement">Basement</option>
                            <option value="Room">Room</option>
                          </select>
                        </div>
                        <div className="col-md-4">
                          <label className="form-label mb-1">Status</label>
                          <select
                            className="form-select"
                            value={unit.unit_status || ''}
                            onChange={(e) => handleUnitChange(index, 'unit_status', e.target.value)}
                          >
                            <option value="">Select status</option>
                            <option value="VACANT">Vacant</option>
                            <option value="OCCUPIED">Occupied</option>
                            <option value="UNDER MAINTENANCE">Under Maintenance</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-muted">No units found for this property.</p>
              )}

            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleCloseModal}>
                Cancel
              </button>
              <button className="btn btn-primary" onClick={handleUpdate} disabled={disableButton}>
               {disableButton ? "Saving..." : "Save Changes"} 
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* BACKDROP */}
      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default EditProperty;
